import React from 'react';
import { WEIGHT, HEIGHT, PERCENT } from '../formats';
import convertKilogramsToPounds from './helpers/convertKilogramsToPounds';
import convertMetersToInches from './helpers/convertMetersToInches';
import formatInchesToFeet from './helpers/formatInchesToFeet';
import formatPercent from './helpers/formatPercent';
import formatPounds from './helpers/formatPounds';

const formatNumber = (data, format) => {
  const parsedFloat = parseFloat(data);

  if (Number.isNaN(parsedFloat)) {
    return <>{data}</>;
  }

  switch (format) {
    case WEIGHT:
      return <>{formatPounds(convertKilogramsToPounds(parsedFloat))}</>;
    case HEIGHT:
      return <>{formatInchesToFeet(convertMetersToInches(parsedFloat))}</>;
    case PERCENT:
      return <>{formatPercent(parsedFloat)}</>;
    default:
      return <>{parsedFloat}</>;
  }
};

export default formatNumber;
